<div id="course-permission" class="container">
  <div class="request-header">
    <b>{{ 'MySpace.AccessRequests' | translate }}</b>
    <button mat-button (click)="getRequests()">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>
  @if (requests.length == 0) {
    <mat-label>
      <br />
      {{ 'MySpace.NoRemainingRequests' | translate }}
    </mat-label>
  }

  @for (request of requests; track request) {
    <mat-card appearance="outlined" class="result-item">
      <div class="card-header">
        <mat-card-header>
          <div mat-card-avatar class="example-header-image">
            <img [src]="request.requester.photo || 'assets/images/no_user.png'" />
          </div>
          <mat-card-title>{{ request.requester.firstName + ' ' + request.requester.lastName }}</mat-card-title>
          <mat-card-subtitle>{{ request.requester.email }}</mat-card-subtitle>
        </mat-card-header>
        <button mat-button (click)="openElementURL(request.courseID)">
          <mat-icon>open_in_new</mat-icon>
        </button>
      </div>
      <div class="course-info mb-1">
        <p>
          <b>{{ 'MySpace.Title' | translate }} :</b>
          {{ request.actualName }}
        </p>
        <p>
          <b>{{ 'MySpace.Description' | translate }} :</b>
          {{ request.actualDescription }}
        </p>
      </div>
      <div>
        <mat-form-field appearance="fill">
          <mat-label>{{ 'Group.Role' | translate }}</mat-label>
          <mat-select name="type" [(ngModel)]="request.role">
            @for (type of userTypes; track type) {
              <mat-option [(value)]="type.value">
                {{ type.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <!-- <button mat-button [disabled]="type" (click)="selectType()">Valider</button> -->
      </div>
      <div>
        <button mat-flat-button color="primary" (click)="acceptRequest(request)">Accepter</button>
        <button mat-flat-button color="accent" (click)="rejectRequest(request._id)">Refuser</button>
      </div>
    </mat-card>
  }
</div>
